export default __webpack_public_path__ + "static/media/letter.980bd7f8.svg";